import IOffer from '~domain/entities/Offer/IOffer';
import { computed, observable, set } from 'mobx';

export default class Offer implements IOffer {
    @observable private offer_id: IOffer['id'];
    @observable private offer_skus: IOffer['skus'];
    @observable private offer_type: IOffer['offerType'];
    @observable private offer_view: IOffer['offerView'];
    @observable private offer_code: IOffer['offerCode'];
    @observable private _description: IOffer['description'];
    @observable private end_date: IOffer['endDate'];
    @observable private image_url: IOffer['imageUrl'];
    @observable private _header: IOffer['header'];
    @observable private _subHeader: IOffer['subHeader'];
    @observable private apply_url: IOffer['applyUrl'];
    @observable private applied_url: IOffer['appliedUrl'];
    @observable private in_cart: IOffer['inCart'] = false;
    @observable private offer_location: IOffer['offerLocation'] = [];
    @observable private is_applying: IOffer['isApplying'] = false;
    @observable private drupal_node_content: IOffer['drupalNodeContent'];
    @observable private _criteria: IOffer['criteria'];
    @observable private threshold_message: IOffer['thresholdMessage'];
    @observable private _messaging: IOffer['messaging'];

    public static cartOffersQualifiedView: string = 'cart_overlay_offers_qualified';
    public static cartOffersNotQualifiedView: string = 'cart_overlay_offers_not_qualified';
    public static cartOffersInCartView: string = 'cart_overlay_offers_in_cart';
    public static appliedOffers: string = 'manual_offers_in_cart';

    @computed
    public get criteria(): IOffer['criteria'] {
        return this._criteria;
    }
    public set criteria(criteria) {
        this._criteria = Object.values(criteria);
        const msg = this._criteria.find((item) => !!item.threshold_message && item) || {};
        this.thresholdMessage = msg?.min
            ? msg.threshold_message?.replace('::minimum_purchase_needed::', msg.min.toString())
            : msg?.threshold_message;
    }

    @computed
    public get thresholdMessage(): IOffer['thresholdMessage'] {
        return this.threshold_message;
    }
    public set thresholdMessage(thresholdMessage: IOffer['thresholdMessage']) {
        this.threshold_message = thresholdMessage;
    }

    @computed
    public get isApplying(): IOffer['isApplying'] {
        return this.is_applying;
    }
    public set isApplying(isApplying: IOffer['isApplying']) {
        this.is_applying = isApplying;
    }

    @computed
    public get applyUrl(): IOffer['applyUrl'] {
        return this.apply_url;
    }
    public set applyUrl(isApplying: IOffer['applyUrl']) {
        this.apply_url = isApplying;
    }

    @computed
    public get appliedUrl(): IOffer['applyUrl'] {
        return this.applied_url;
    }
    public set appliedUrl(isApplying: IOffer['applyUrl']) {
        this.applied_url = isApplying;
    }

    @computed
    public get offerCode(): IOffer['offerCode'] {
        return this.offer_code;
    }
    public set offerCode(code: IOffer['offerCode']) {
        this.offer_code = code;
    }

    @computed
    public get offerType(): IOffer['offerType'] {
        return this.offer_type;
    }
    public set offerType(type: IOffer['offerType']) {
        this.offer_type = type;
    }

    @computed
    public get offerView(): IOffer['offerView'] {
        return this.offer_view;
    }
    public set offerView(view: IOffer['offerView']) {
        this.offer_view = view;
    }

    @computed
    public get id(): IOffer['id'] {
        return this.offer_id;
    }
    public set id(id: IOffer['id']) {
        this.offer_id = id;
    }

    @computed
    public get skus(): IOffer['skus'] {
        return this.offer_skus;
    }
    public set skus(skus: IOffer['skus']) {
        this.offer_skus = skus;
    }

    @computed
    public get description(): IOffer['description'] {
        return this._description;
    }
    public set description(description: IOffer['description']) {
        this._description = description;
    }

    @computed
    public get endDate(): IOffer['endDate'] {
        return this.end_date;
    }
    public set endDate(date: IOffer['endDate']) {
        this.end_date = date;
    }

    @computed
    public get imageUrl(): IOffer['imageUrl'] {
        return this.image_url;
    }
    public set imageUrl(url: IOffer['imageUrl']) {
        this.image_url = url;
    }

    @computed
    public get header(): IOffer['header'] {
        return this._header;
    }
    public set header(header: IOffer['header']) {
        this._header = header;
    }

    @computed
    public get subHeader(): IOffer['subHeader'] {
        return this._subHeader;
    }
    public set subHeader(subHeader: IOffer['subHeader']) {
        this._subHeader = subHeader;
    }

    @computed
    public get inCart(): IOffer['inCart'] {
        return this.in_cart;
    }
    public set inCart(inCart: IOffer['inCart']) {
        this.in_cart = inCart;
    }

    @computed
    public get offerLocation(): IOffer['offerLocation'] {
        return this.offer_location;
    }
    public set offerLocation(location: IOffer['offerLocation']) {
        this.offer_location = location;
    }

    @computed
    public get drupalNodeContent(): IOffer['drupalNodeContent'] {
        return this.drupal_node_content;
    }
    public set drupalNodeContent(drupal_node_content: IOffer['drupalNodeContent']) {
        this.drupal_node_content = drupal_node_content;
    }

    public get messaging(): IOffer['messaging'] {
        return this._messaging;
    }

    public static fromJSON(data: IOffer): Offer {
        const offer = new Offer();
        set(offer, data);

        return offer;
    }
}
